import { OptimizelyXhtmlString } from "..";
import { OptimizelyBlockExpandedValue } from "../expanded";

export interface TextBlockData extends OptimizelyBlockExpandedValue {
    contentType: ['Block', 'TextBlock'];
    text: OptimizelyXhtmlString;
};

export const isTextBlockData = (
    block: OptimizelyBlockExpandedValue
  ): block is TextBlockData => {
    return block.contentType[1] === 'TextBlock';
  };